import { InspectorContext } from "../../reducer";
import { useAcceptRejectAll, useHandleFieldChanged } from "../../hooks";
import { useContext } from "react";
import { useModal } from "@/hooks";
import { DefectSelection } from "../DefectSelection";

export function BWI() {
  const { state } = useContext(InspectorContext);

  const modal = useModal();
  const acceptReject = useAcceptRejectAll();
  const handleFieldChanged = useHandleFieldChanged();

  return (
    <>
      <thead>
        <tr>
          <th>Weld Map</th>
          <th>Drawing No.</th>
          <th>Weld ID No.</th>
          <th>Work Instruction</th>
          <th>Joint Type</th>
          <th>WPS</th>
          <th>Root Gap (mm)</th>
          <th>Backing Material Required</th>
          <th>Linear Alignment Max (mm)</th>
          <th>Accept</th>
          <th>Reject</th>
          <th>Defects</th>
        </tr>
      </thead>
      <tbody>
        {state.inspections.map((row, index) => (
          <tr key={index}>
            <td>{row.weldMap}</td>
            <td>{row.drawingNumber}</td>
            <td>{row.weldNumber}</td>
            <td>{row.workInstruction}</td>
            <td>{row.jointType}</td>
            <td>{row.wpsNumber}</td>
            <td>{row.rootGap}</td>
            <td>{row.backingMaterial}</td>
            <td>{row.linearAlignment}</td>
            <td>
              <input
                type="radio"
                className="form-check-input"
                name={`result${index}`}
                checked={row.accept === true}
                onChange={() => handleFieldChanged(index, "accept", true)}
                onClick={(e) => e.currentTarget.checked && handleFieldChanged(index, "accept", undefined)}
              />
            </td>
            <td>
              <input
                type="radio"
                className="form-check-input"
                name={`result${index}`}
                checked={row.accept === false}
                onChange={() => handleFieldChanged(index, "accept", false)}
                onClick={(e) => e.currentTarget.checked && handleFieldChanged(index, "accept", undefined)}
              />
            </td>
            <td>
              <button
                role="link"
                className="btn btn-link"
                disabled={row.accept !== false}
                onClick={() =>
                  modal.show(
                    <DefectSelection
                      caption="Defects"
                      weld={row}
                      onAccept={(defects) => handleFieldChanged(index, "defects", defects)}
                    />
                  )
                }
              >
                {row.defects?.length > 0 ? `${row.defects?.length} Selected` : "Click to select"}
              </button>
            </td>
          </tr>
        ))}
      </tbody>

      {state.inspections.length > 1 && (
        <tfoot>
          <tr>
            <td />
            <td />
            <td />
            <td />
            <td />
            <td />
            <td />
            <td />
            <td />
            <td>
              <button type="button" className="btn btn-default btn-sm" onClick={acceptReject.acceptAll}>
                Accept all
              </button>
            </td>
            <td>
              <button type="button" className="btn btn-default btn-sm" onClick={acceptReject.rejectAll}>
                Reject All
              </button>
            </td>
            <td></td>
          </tr>
        </tfoot>
      )}
    </>
  );
}
